import styled from "@emotion/styled";
import { Styles } from "@tpd-web-common-libs/nodejs-library";

export const Item = styled.div<{ disposizione: string }>`
  margin-bottom: 30px;
  flex-direction: ${(props) =>
    props.disposizione === "Destra" ? "row-reverse" : "unset"};

  .tpd-image {
    width: 100%;
    height: auto;
  }

  .tpd-content-title {
    font-family: Unipol Medium;
    font-size: 30px;
    line-height: 37px;
    margin-bottom: 20px;
    padding-top: 25px;
    padding-bottom: 20px;
    color: ${Styles.Themes.UnipolColors.blueOne};
  }

  .tpd-content-text {
    font-family: Unipol Medium;
    font-size: 34px;
    line-height: 42px;
    color: ${Styles.Themes.UnipolColors.blueSeven};
  }

  .tpd-author {
    margin-bottom: 20px;
  }

  .tpd-content-description {
    font-family: Unipol;
    font-size: 16px;
    line-height: 1.42857143;

    .rich-text-container {
      p {
        margin-bottom: 10px;
      }
    }
  }
  .tpd-link-container {
    .tpd-cta-container, .tpd-cta-edit-mode-container {
      font-family: 'Unipol Bold';
      text-decoration: underline;
      color: #0f3250;
      font-size: 16px;
    }
  }
  .tpd-content-buttons {
    .tpd-cta-container {
      box-sizing: border-box;
      margin-top: 30px;
      margin-bottom: 0;
      font-weight: 600;
      text-align: center;
      vertical-align: middle;
      background-image: none;
      border: 1px solid transparent;
      white-space: nowrap;
      padding: 6px 12px;
      border-radius: 4px;
      user-select: none;
      border-radius: 0;
      height: 42px;
      border: none;
      border-bottom: 5px solid #c4151c;
      font-family: Unipol Bold;
      font-size: 16px;
      background-color: #fff;
      min-width: 155.8px;
      min-height: 48px;
      line-height: 32px;
      display: inline-block;
      text-decoration: none;

      &:hover {
        color: #c4151c;
      }
    }
  }

  ${Styles.BreakpointsUtils.mobileOnly(`
    .tpd-image {
      margin-bottom: 27px;
    }

    .tpd-content-title {
      padding-top: 0;
      padding-bottom: 0;
    }

    .tpd-content-text {
      font-size: 16px;
      line-height: 23px;
    }
  `)}

  ${Styles.BreakpointsUtils.tabletAndDesktopOnly(`
    display: flex;
    align-items: start;
    margin-bottom: 70px;

    .tpd-side-text .tpd-content-description {
      margin-right: 5px;
    }

    .tpd-short-text {
      font-size: 33px;
    }

    .tpd-image {
      width: 40%;
    }

    .tpd-side-text {
      width: 55%;
      margin-left: 45px;
    }

    .tpd-content-title {
      margin-top: 0;
      margin-bottom: 0;
      padding-top: 0;
      font-size: 20px;
      line-height: 32px;
    }

    .tpd-content-description {
      font-size: 18px;
    }
  `)}

    ul {
    padding-bottom: 10px;
    margin-left: 30px;
  }

  ${Styles.BreakpointsUtils.tabletOnly(`
    .tpd-image {
            img {
        aspect-ratio: 1.25;
      }
    }
    .tpd-content-title {
      line-height: 24px;
    }
  `)}

  ${Styles.BreakpointsUtils.desktopOnly(`
    max-width: 952px;
    margin-bottom: 55px;

    :last-child {
      margin-bottom: 40px;
    }

    .tpd-short-text .tpd-short-text-container {
      margin-left: 12.5%;
      margin-right: 12.5%;
    }

    .tpd-image {
      width: 36%;
      padding-left: 10px;
      padding-right: 4px;

      img {
        width: 100%;
        height: 250px;
      }
    }

    .tpd-side-text {
      width: 65%;
      margin-left: 60px;
    }

    .tpd-content-title {
      font-size: 25px;
    }
  `)}
`;
